import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import "@arco-design/web-react/es/Empty/style";
import _Empty from "@arco-design/web-react/es/Empty";
import React, { useMemo } from 'react';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';

/** 后端返回的列定义（GET preview_url 的 data.columns） */

/** 默认值响应体：列元信息 + 数据行（数据行可含 children 构成树形） */

/** 后端行数据没有唯一主键，此处递归注入行 key（含 children） */
const ROW_KEY = '__row_key';
function withRowKey(rows, prefix = '') {
  return (rows || []).map((row, index) => {
    const key = `${prefix}${index}`;
    const next = {
      ...row,
      [ROW_KEY]: key
    };
    if (Array.isArray(row?.children) && row.children.length) {
      next.children = withRowKey(row.children, `${key}-`);
    }
    return next;
  });
}

/** 默认值预览：完全由后端 columns / data 结构驱动，支持 children 树形展示 */
function DefaultPreview(props) {
  const {
    value,
    loading
  } = props;
  const t = useLocale(locale);
  const columns = useMemo(() => (value?.columns || []).map(c => ({
    title: c.title || c.field,
    dataIndex: c.field,
    width: c.width,
    ellipsis: true,
    tooltip: true
  })), [value]);
  const rows = useMemo(() => withRowKey(value?.data || []), [value]);

  /** 含 children 时为树形数据：关闭分页，整棵展开交由用户控制 */
  const isTree = useMemo(() => rows.some(r => Array.isArray(r.children) && r.children.length > 0), [rows]);

  /** 列宽之和超出容器时才出现横向滚动条 */
  const scrollX = useMemo(() => {
    const cols = value?.columns || [];
    const total = cols.reduce((sum, c) => sum + (c.width || 0), 0);
    return cols.length && total ? total : undefined;
  }, [value]);
  if (!loading && (!columns.length || !rows.length)) {
    return /*#__PURE__*/React.createElement(_Empty, {
      description: t['public.hint.no_data']
    });
  }
  return /*#__PURE__*/React.createElement(_Spin, {
    loading: !!loading,
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['default-title']
  }, t['init.title.default_preview']), /*#__PURE__*/React.createElement(_Table, {
    size: "small",
    border: true,
    rowKey: ROW_KEY,
    columns: columns,
    data: rows,
    scroll: {
      y: 360,
      ...(scrollX ? {
        x: scrollX
      } : {})
    },
    pagination: isTree ? false : {
      pageSize: 10,
      sizeCanChange: false,
      showTotal: true
    }
  }));
}
export default DefaultPreview;